<template>
    <b-button-group size="sm" class="btn-block">
        <b-button
            :pressed="otherTaxFilter === 'oth'"
            variant="outline-secondary"
            @click="updateOtherTaxFilter('oth')"
        >
            Toutes
        </b-button>
        <b-button
            :pressed="otherTaxFilter === 'cfe'"
            variant="outline-primary"
            @click="updateOtherTaxFilter('cfe')"
        >
            CFE
        </b-button>
        <b-button
            :pressed="otherTaxFilter === 'cva'"
            variant="outline-primary"
            @click="updateOtherTaxFilter('cva')"
        >
            CVAE
        </b-button>
        <b-button
            :pressed="otherTaxFilter === 'dsi'"
            variant="outline-primary"
            @click="updateOtherTaxFilter('dsi')"
        >
            DSI
        </b-button>
        <b-button
            :pressed="otherTaxFilter === 'tss'"
            variant="outline-primary"
            @click="updateOtherTaxFilter('tss')"
        >
            Taxe sur salaires
        </b-button>
        <b-button
            :pressed="otherTaxFilter === 'tsc'"
            variant="outline-primary"
            @click="updateOtherTaxFilter('tsc')"
        >
            Tascom
        </b-button>
    </b-button-group>
</template>

<script>
import {mapState} from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater.vue'

export default {
    name: 'OtherTaxFilter',

    mixins: [DataUpdater],

    computed: {
        ...mapState({
            otherTaxFilter: (state) => state.browsing.otherTaxFilter,
        }),
    },

    methods: {
        updateOtherTaxFilter(value) {
            this.$store.commit('browsing/SET_OTHER_TAX_FILTER', value)
            this.$root.$refs.otherTaxTable.getItems()
        },
    },
}
</script>

<style scoped></style>
